import { TourSteps } from "../../Data/Messenger/Messenger";
import MessengerContainer from "./Messenger";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import { Fragment, useEffect, useRef, useState } from "react";
import { TourGuideClient } from "@sjmc11/tourguidejs";
import { toast } from "react-toastify";

const Messenger = () => {
  const { appSidebarWidth } = useAppSelector((state) => state.appSidebar);
  const tourRef = useRef<any | null>(null);
  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(() => {
    if (appSidebarWidth >= 993) {
      const timer = setTimeout(() => setIsTourOpen(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [appSidebarWidth]);

  useEffect(() => {
    try {
      tourRef.current = new TourGuideClient({ steps: TourSteps });
    } catch (error) {
      toast.error("Error initializing TourGuideClient:" + error);
    }
    return () => tourRef.current?.destroy?.();
  }, []);

  useEffect(() => {
    if (isTourOpen) tourRef.current?.start?.();
  }, [isTourOpen]);

  return (
    <Fragment>
      <MessengerContainer />
    </Fragment>
  );
};

export default Messenger;
